export default "__VITE_ASSET__CWn8y4GB__"